<template>
  <div>
    <div class="mapouter">
      <div class="mapinner">
        <iframe
          :src="iframeSrc"
          width="300"
          height="300"
          class="mapiframe"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Gps",
  props: {
    result: Object,
  },
  computed: {
    gpsValue() {
      return this.result?.value;
    },
    iframeSrc() {
      return `https://maps.google.com/maps?q=${this.gpsValue}&t=&z=13&ie=UTF8&iwloc=&output=embed`;
    },
  },
};
</script>

<style>
.mapouter {
  position: relative;
  text-align: right;
  height: 300px;
  width: 100%;
}
.mapinner {
  overflow: hidden;
  background: none !important;
  height: 300px;
  width: 100%;
}
.mapiframe {
  width: 100%;
}
</style>
